import { ArrowRight, Globe } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* By region */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Globe className="h-4 w-4 text-gray-500" aria-hidden="true" />
              <h3 className="text-sm font-semibold text-gray-900">DeepSeek by region</h3>
            </div>
            <ul className="space-y-2">
              <li><Link to="/deepseek-usa" className="text-sm text-gray-600 hover:text-primary">🇺🇸 DeepSeek USA</Link></li>
              <li><Link to="/deepseek-uk" className="text-sm text-gray-600 hover:text-primary">🇬🇧 DeepSeek UK</Link></li>
              <li><Link to="/deepseek-canada" className="text-sm text-gray-600 hover:text-primary">🇨🇦 DeepSeek Canada</Link></li>
              <li><Link to="/deepseek-deutsch" className="text-sm text-gray-600 hover:text-primary">🇩🇪 DeepSeek Deutsch</Link></li>
            </ul>
          </div>

          {/* Models & guides */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Models &amp; guides</h3>
            <ul className="space-y-2">
              <li><Link to="/deepseek-v4" className="text-sm text-gray-600 hover:text-primary">DeepSeek V4</Link></li>
              <li><Link to="/deepseek-r1" className="text-sm text-gray-600 hover:text-primary">DeepSeek R1</Link></li>
              <li><Link to="/deepseek-api" className="text-sm text-gray-600 hover:text-primary">DeepSeek API</Link></li>
              <li><Link to="/is-deepseek-safe" className="text-sm text-gray-600 hover:text-primary">Is DeepSeek safe?</Link></li>
            </ul>
          </div>

          {/* Compare */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Compare DeepSeek</h3>
            <ul className="space-y-2">
              <li><Link to="/deepseek-vs-chatgpt" className="text-sm text-gray-600 hover:text-primary">vs ChatGPT</Link></li>
              <li><Link to="/deepseek-vs-claude" className="text-sm text-gray-600 hover:text-primary">vs Claude</Link></li>
              <li><Link to="/deepseek-vs-gemini" className="text-sm text-gray-600 hover:text-primary">vs Gemini</Link></li>
              <li><Link to="/deepseek-vs-llama" className="text-sm text-gray-600 hover:text-primary">vs Llama</Link></li>
              <li><Link to="/deepseek-vs-mistral" className="text-sm text-gray-600 hover:text-primary">vs Mistral</Link></li>
              <li><Link to="/deepseek-vs-perplexity" className="text-sm text-gray-600 hover:text-primary">vs Perplexity</Link></li>
              <li><Link to="/deepseek-vs-stepfun" className="text-sm text-gray-600 hover:text-primary">vs Stepfun</Link></li>
            </ul>
          </div>

          {/* About this site */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">About this guide</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-primary">Who runs this site</Link></li>
              <li><Link to="/deepseek-ai" className="text-sm text-gray-600 hover:text-primary">What is DeepSeek AI?</Link></li>
              <li><Link to="/deepseek-coder" className="text-sm text-gray-600 hover:text-primary">DeepSeek Coder</Link></li>
              <li><Link to="/deepseek-stock" className="text-sm text-gray-600 hover:text-primary">DeepSeek stock &amp; IPO</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-600 hover:text-primary">Contact</Link></li>
              <li><Link to="/privacy-policy" className="text-sm text-gray-600 hover:text-primary">Privacy policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 flex flex-col items-center justify-center space-y-3">
          <p className="text-sm text-gray-500 text-center">
            The Independent DeepSeek Guide (deepseek.ai) is not affiliated with, endorsed by, or connected to DeepSeek
            (Hangzhou DeepSeek Artificial Intelligence Co., Ltd.) or DeepSeek.com in any way. &quot;DeepSeek&quot; is a
            trademark of its respective owner.
          </p>
          <a
            href="https://www.deepseek.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#0b57d0] hover:text-[#0b57d0]/80 transition-colors flex items-center"
            aria-label="Visit DeepSeek.com in a new tab"
          >
            Looking for DeepSeek.com?
            <ArrowRight className="ml-1 h-4 w-4 inline" aria-hidden="true" />
          </a>
          <p className="text-sm text-gray-500 text-center">
            © {new Date().getFullYear()} The Independent DeepSeek Guide. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 text-center">
            deepseek.ai is a service of Extchange B.V. · Chamber of Commerce (KvK) 98317024 · Kienhuislanden 12,
            7542 WL Enschede, the Netherlands
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
